var _mask, _rect, _mask2, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadInLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 1,
    fill: "white",
    stroke: "#0E4C54",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 11,
    height: 11,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 11,
    height: 11,
    rx: 1,
    fill: "white",
    stroke: "#0E4C54",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32538,
    y: 12.9492,
    width: 7,
    height: 1.4,
    rx: 0.7,
    transform: "rotate(-45 7.32538 12.9492)",
    fill: "#364863"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.98993,
    y: 10.6738,
    width: 3.23663,
    height: 1.4,
    rx: 0.7,
    transform: "rotate(45 6.98993 10.6738)",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInLot);
export default __webpack_public_path__ + "static/media/download-in-lot.079976671e271ca1c6f33e7a6d116a24.svg";
export { ForwardRef as ReactComponent };